import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import ArrowIcon from '@material-ui/icons/ArrowForwardIos';

import useFetch from 'src/hooks/useFetch';
import { formatMoney } from 'src/utils/common';

import Container from '../../../../components/Layouts/Container';
import { Title } from 'src/components/Title';
import { formatServico } from '../../utils/formatServico';

import { useStyles } from './styles';

export function ListaServicos() {
  const classes = useStyles();

  const history = useHistory();

  const [data, isLoading, isError] = useFetch('/servicos');

  const [servicos, setServicos] = useState([]);

  useEffect(() => {
    if (Array.isArray(data)) {
      const tratedServicos = [];

      data.forEach((servico) => {
        if (servico.uuid !== '86c0da3f-a573-4c6d-a4a5-d06838a06b54') {
          const formatedServico = formatServico(servico);

          tratedServicos.push(formatedServico);
        }
      });

      setServicos(tratedServicos);
    }
  }, [data]);

  const handleServicoClick = (servico) => {
    history.push({
      pathname: `/servicosUsuario/detalhe/${servico.id}`,
      state: {
        servico,
      },
    });
  };

  console.log(servicos);

  return (
    <Container isLoading={isLoading} isError={isError}>
      <Title>Selecione um serviço</Title>

      <List className={classes.root}>
        {servicos?.map((servico) => {
          return (
            <ListItem
              key={servico.id}
              button
              divider
              onClick={() => handleServicoClick(servico)}
            >
              <div className={classes.listContentContainer}>
                <ListItemText
                  primary={servico.nome}
                  className={classes.listItemHeader}
                />
                <ListItemText
                  primary={formatMoney(servico.valor)}
                  secondary={servico.stringParcela}
                />
              </div>
              <ListItemAvatar className={classes.listIcon}>
                <Avatar>
                  <ArrowIcon />
                </Avatar>
              </ListItemAvatar>
            </ListItem>
          );
        })}
      </List>
    </Container>
  );
}

export default ListaServicos;
